import moment from "moment";

import { Show } from "../models/Shows";

const useEpisodeLabel = (show: Show, episode: number): string => {
    if (show) {
        if (show.weeks && show.weeks.length > 0) {
            const week = show.weeks.find(
                (item) => item.week_number === episode
            );
            if (week) {
                const episodes = week.episodes;
                if (episodes.length === 0) return "";

                const firstEp = episodes[0];
                const lastEp = episodes[episodes.length - 1];

                const epLabel =
                    episodes.length === 1
                        ? `Ep. ${firstEp.episode_number}`
                        : `Eps. ${firstEp.episode_number}–${lastEp.episode_number}`;

                const firstDate = moment(firstEp.lock_date).format("MM/DD");
                const lastDate = moment(lastEp.lock_date).format("MM/DD");

                const dateLabel =
                    firstDate === lastDate
                        ? firstDate
                        : `${firstDate}-${lastDate}`;
                return `${epLabel}, ${dateLabel}`;
            }
        } else if (show.episodes_list && show.episodes_list.length > 0) {
            const ep = show.episodes_list.find(
                (item) => item.episode_number === episode
            );
            if (ep) {
                return moment(ep.lock_date).format("MM/DD");
            }
        }
    }

    return "";
};

export default useEpisodeLabel;
